import * as React from "react";
import * as _ from "lodash";
import * as moment from "moment";
import { IApSbsItem } from "@nkr/models/index";
import { toast } from "react-toastify";
import { Button, InputGroup, FormControl, Badge } from 'react-bootstrap';
import { toPath } from "lodash";
interface IProps {
    rank: number,
    data: IApSbsItem,
    updatePayment: (sbsItem: IApSbsItem) => void
}

interface IState {
    [index: string]: string | number | boolean,
    paidDate: string,
    achNumber: string,
    hospitalFee: number,
    surgeonFee: number,
    anesFee: number,
    totalFees: number,
    comments: string,
    inputChange : boolean,
    centerHasAchOnFile: boolean
}


class BilledByCenterRow extends React.Component<IProps, IState> {
    readonly state: IState = {
        achNumber: '',
        paidDate: '',
        comments: '',
        hospitalFee: 0,
        surgeonFee: 0,
        anesFee: 0,
        totalFees: 0,
        centerHasAchOnFile: false,
        inputChange: false
    }

    handleInputChange = (e: React.FormEvent<HTMLInputElement & FormControl>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        //validate value
        if (name == 'hospitalFee' || name == 'anesFee' || name == 'surgeonFee') {
            let newValue = Number(value.substring(0, 5));

            let newTotalFees = name == 'hospitalFee' ? newValue : this.state.hospitalFee;
            newTotalFees += name == 'anesFee' ? newValue : this.state.anesFee;
            newTotalFees += name == 'surgeonFee' ? newValue : this.state.surgeonFee;

            this.setState({
                [name]: newValue,
                totalFees: newTotalFees
            });

        } else {
            this.setState({
                [name]: value,
                inputChange: true
            });
        }
    }

    componentDidUpdate(prevList) {

        if(prevList.data != this.props.data)
        {
            let totalFees = this.props.data.hospitalFee + this.props.data.surgeonFee + this.props.data.anesthesiologistFee;
        
            if(this.props.data.paidDateTime == null && !this.state.inputChange)
            {
                this.setState({
                    paidDate: this.props.data.paidDateTime != null ? moment(this.props.data.paidDateTime).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
                    hospitalFee: this.props.data.hospitalFee,
                    surgeonFee: this.props.data.surgeonFee,
                    anesFee: this.props.data.anesthesiologistFee,
                    totalFees: totalFees
                });
            } 
        }
        
      } 

    componentDidMount = () => {
        let totalFees = this.props.data.hospitalFee + this.props.data.surgeonFee + this.props.data.anesthesiologistFee;

        this.setState({
            paidDate: this.props.data.paidDateTime != null ? moment(this.props.data.paidDateTime).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
            hospitalFee: this.props.data.hospitalFee,
            surgeonFee: this.props.data.surgeonFee,
            anesFee: this.props.data.anesthesiologistFee,
            totalFees: totalFees
        });
    }

    handlePaymentUpdate = () => {
        //validate all information is populated
        if (this.state.achNumber == null || this.state.paidDate == null) {
            toast.error('Missing fields.  Please validate data.');
            return;
        }

        let rowData = _.cloneDeep(this.props.data);
        rowData.achConfirmation = this.state.achNumber;
        rowData.paidDateTime = this.state.paidDate;
        rowData.hospitalFee = this.state.hospitalFee;
        rowData.surgeonFee = this.state.surgeonFee;
        rowData.anesthesiologistFee = this.state.anesFee;

        this.props.updatePayment(rowData);

        this.setState({
            achNumber: '',
            paidDate: '',
            inputChange: true
        });
    }

    render = () => {
        var isPaid = this.props.data.paidDateTime != null && this.props.data.paidDateTime.length > 0;

        return (
            <>
            <tr>
                <td style={{ maxWidth: '10px'}}>{this.props.rank}</td>
                <td>{this.props.data.swap}</td>
                <td><Badge>{moment(this.props.data.invoiceDate).format('MM/DD/YYYY')}</Badge></td>
                <td>{this.props.data.daysOutstanding.toLocaleString()}</td>
                <td>{this.props.data.donorCenterAlias}</td>

                <td style={{ width:"40px" }}>
                    <a target={'_blank'} href={`center/${this.props.data.donorCenterId}/donor/${this.props.data.donorId}/profile/donor-data`}>
                        {this.props.data.donorAlias}
                    </a>
                </td>

                <td>{this.props.data.recipientCenterAlias}</td>
                <td>
                    <a target={'_blank'} href={`center/${this.props.data.recipientCenterId}/recipient/${this.props.data.recipientId}/profile/general`}>
                            {this.props.data.recipientAlias}
                    </a>
                </td>

                <td style={{textAlign:"right"}}>
                    {isPaid 
                        ? this.props.data.surgeonFee == 0 
                            ? '--'
                            : this.props.data.surgeonFee.toLocaleString(undefined, {maximumFractionDigits:0}) :
                    <InputGroup className="mb-3" style={{ display: "flex", minWidth:"70px", maxWidth:"100px" }}>
                        <FormControl
                            type="number"
                            name="surgeonFee"
                            value={this.state.surgeonFee}
                            onChange={this.handleInputChange}
                        />
                    </InputGroup>}
                </td>

                <td style={{textAlign:"right"}}>
                    {isPaid 
                        ? this.props.data.anesthesiologistFee == 0 
                            ? '--'
                            : this.props.data.anesthesiologistFee.toLocaleString(undefined, {maximumFractionDigits:0}) :
                    <InputGroup maxLength={5} className="mb-3" style={{ display: "flex", minWidth:"70px", maxWidth:"100px" }}>
                        <FormControl
                            type="number"
                            name="anesFee"
                            value={this.state.anesFee}
                            onChange={this.handleInputChange}
                        />
                    </InputGroup>}
                </td>

                <td style={{textAlign:"right"}}>
                    {isPaid ? 
                        (this.props.data.hospitalFee == 0 
                            ? '--' 
                            : this.props.data.hospitalFee.toLocaleString('en', {maximumFractionDigits:0})) :
                        <InputGroup className="mb-3" style={{ display: "flex", minWidth:"70px", maxWidth:"100px" }}>
                            <FormControl
                                type="number"
                                name="hospitalFee"
                                value={this.state.hospitalFee}
                                onChange={this.handleInputChange}
                            />
                        </InputGroup>}
                </td>

                <td style={{textAlign:"right"}}>
                    {!isPaid ? 
                    (this.state.totalFees == 0 
                        ? '--' 
                        : this.state.totalFees.toLocaleString('en', {maximumFractionDigits:0})) 
                    : (this.props.data.totalFees == 0
                        ? '--'
                        : this.props.data.totalFees.toLocaleString('en', {maximumFractionDigits:0}))
                    }
                </td>

                <td>
                {(!this.props.data.hasOutstandingDelinquency && !this.props.data.hasLate) 
                    ? <Badge style={{ backgroundColor: 'green', fontSize: 12 }}>{moment(this.props.data.invoiceDate, "YYYY-MM-DD").add(this.props.data.ccbPayableDays, 'days').format("MM/DD/YYYY")}</Badge>
                    : (!this.props.data.hasOutstandingDelinquency && this.props.data.hasLate) 
                        ? <Badge style={{ backgroundColor: 'orange', fontSize: 12 }}>{moment(this.props.data.invoiceDate, "YYYY-MM-DD").add(this.props.data.ccbPayableDays, 'days').format("MM/DD/YYYY")}</Badge>
                        : this.props.data.hasOutstandingDelinquency ? <Badge style={{ backgroundColor: 'red', fontSize: 12 }}>Do Not Pay</Badge> : <> </>}
                </td>

                <td>
                    {this.props.data.centerHasAchOnFile ? <span className="label label-success">Y</span> : <span className="label label-danger">N</span>}
                </td>

                <td>
                    {isPaid ? <Badge>{moment(this.props.data.paidDateTime).format("MM/DD/YYYY")}</Badge> : <InputGroup className="mb-3" style={{ display: "flex", width: "150px" }}>
                        <FormControl
                            type="date"
                            name="paidDate"
                            value={this.state.paidDate}
                            onChange={this.handleInputChange}
                        />
                    </InputGroup>}
                </td>

                <td>
                    {isPaid ? this.props.data.achConfirmation : <InputGroup className="mb-3" style={{ display: "flex" }}>
                        <FormControl
                            type="text"
                            placeholder="ACH Confirmation"
                            name="achNumber"
                            value={this.state.achNumber}
                            onChange={this.handleInputChange} />

                    </InputGroup>}

                </td>

                <td>
                    {isPaid ? this.state.comments : <InputGroup className="mb-3" style={{ display: "flex" }}>
                        <FormControl
                            placeholder="Addl Comments"
                            name="comments"
                            value={this.state.comments}
                            onChange={this.handleInputChange} />
                    </InputGroup>}
                </td>

                <td>
                    {isPaid ? <Badge>Paid</Badge> :
                        <Button onClick={this.handlePaymentUpdate} bsSize="small" className="btn-primary" id="button-addon2">
                            Mark Paid
                        </Button>}
                </td>
            </tr>
            </>
        )
    }
}

export default BilledByCenterRow;